import * as React from 'react';
import * as Loadable from 'react-loadable';
import { LoadingSpinner } from '@common/components';

export const AsyncPropertyManager = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PropertyManagementModule" */ 'src/property-manager').then(m => m.PropertyManager),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncPropertyManagerSearch = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PropertyManagementModule" */ 'src/property-manager').then(
      m => m.PropertyManagerSearch
    ),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncPropertyManagerDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PropertyManagementModule" */ 'src/property-manager').then(
      m => m.PropertyManagerDetail
    ),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncPropertyManagementOffice = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PropertyManagementModule" */ 'src/property-management').then(
      m => m.PropertyManagementOffice
    ),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncPropertyManagementOfficeSearch = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PropertyManagementModule" */ 'src/property-management').then(
      m => m.PropertyManagementOfficeSearch
    ),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});

export const AsyncPropertyManagementOfficeDetails = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PropertyManagementModule" */ 'src/property-management').then(
      m => m.PropertyManagementOfficeDetails
    ),
  loading: () => <LoadingSpinner />,
  render: (loaded: any, props: any) => {
    let Component = loaded;
    return <Component {...props} />;
  },
  delay: 300,
  timeout: 10000
});



// WEBPACK FOOTER //
// ./src/_Modules/property-mgmt.module.tsx